export default __webpack_public_path__ + "static/media/documents.66b6a450.svg";